// Opens your badges from anywhere (#201): the badge toast's button. App
// switches to the Activity tab; the Badges card opens its sheet once it's
// there, which may be after the event fired, so the request also waits in
// `pending`.
const OPEN_EVENT = "khronos:open-badges";
let pending = false;

export const openBadges = () => {
  pending = true;
  window.dispatchEvent(new CustomEvent(OPEN_EVENT));
};

export const onOpenBadges = (handler) => {
  window.addEventListener(OPEN_EVENT, handler);
  return () => window.removeEventListener(OPEN_EVENT, handler);
};

/** True once per request: the card that opens the sheet takes it. */
export const takeBadgesRequest = () => {
  const was = pending;
  pending = false;
  return was;
};

// Badges just earned by a session you saved (#204): shown in a sheet rather
// than a toast. The badge check runs after the save, so the notification
// lands a moment later; a save in the last few minutes means it's this one.
const EARNED_EVENT = "khronos:badges-earned";
const RECENT_SAVE_MS = 5 * 60 * 1000;
let lastSaveAt = 0;

export const noteSessionSaved = (now = Date.now()) => {
  lastSaveAt = now;
};

export const savedRecently = (now = Date.now()) => lastSaveAt > 0 && now - lastSaveAt <= RECENT_SAVE_MS;

export const showEarned = (keys) => window.dispatchEvent(new CustomEvent(EARNED_EVENT, { detail: keys || [] }));

export const onShowEarned = (handler) => {
  const listener = (e) => handler(e.detail);
  window.addEventListener(EARNED_EVENT, listener);
  return () => window.removeEventListener(EARNED_EVENT, listener);
};

// A rare effort from the session just saved (api/lib/rareEffort.js): told
// once as a message, and kept a few minutes for the badges sheet that may
// follow.
const RARE_EVENT = "khronos:rare-effort";
let lastRare = null;

export const showRareEffort = (effort, now = Date.now()) => {
  if (!effort?.text) return;
  lastRare = { effort, at: now };
  window.dispatchEvent(new CustomEvent(RARE_EVENT, { detail: effort }));
};

export const recentRareEffort = (now = Date.now()) =>
  lastRare && now - lastRare.at <= RECENT_SAVE_MS ? lastRare.effort : null;

export const onRareEffort = (handler) => {
  const listener = (e) => handler(e.detail);
  window.addEventListener(RARE_EVENT, listener);
  return () => window.removeEventListener(RARE_EVENT, listener);
};
